import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Stethoscope, Loader2, Lock } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MediProviderLogin() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(`${API}/mediprovider/login`, { email, password });
            localStorage.setItem('provider_token', response.data.token);
            localStorage.setItem('provider_user', JSON.stringify(response.data.provider));
            toast.success('Welcome back!');
            navigate('/mediprovider/dashboard');
        } catch (err) {
            toast.error(err.response?.data?.detail || 'Invalid credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-teal-50 to-cyan-50 dark:from-slate-900 dark:to-slate-800 flex items-center justify-center p-4">
            <Card className="w-full max-w-md border-teal-200 dark:border-teal-800">
                <CardHeader className="text-center">
                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center mx-auto mb-4">
                        <Stethoscope className="w-8 h-8 text-white" />
                    </div>
                    <CardTitle className="text-2xl">MediProvider Portal</CardTitle>
                    <CardDescription>Sign in to manage your services</CardDescription>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-2">
                            <Label>Email</Label>
                            <Input 
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="your@email.com"
                                required
                            />
                        </div>
                        <div className="space-y-2">
                            <Label>Password</Label>
                            <Input 
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                        </div>
                        <Button 
                            type="submit" 
                            className="w-full bg-teal-500 hover:bg-teal-600"
                            disabled={loading}
                        >
                            {loading ? (
                                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                            ) : (
                                <Lock className="w-4 h-4 mr-2" />
                            )}
                            Sign In
                        </Button>
                    </form>
                    <div className="mt-6 text-center space-y-2">
                        <p className="text-sm text-muted-foreground">
                            Don't have an account?{' '}
                            <Link to="/mediprovider/register" className="text-teal-600 hover:underline">
                                Register here
                            </Link>
                        </p>
                        <p className="text-sm text-muted-foreground">
                            <Link to="/" className="hover:text-teal-600">
                                ← Back to MediGuide
                            </Link>
                        </p>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
